module.exports = __webpack_public_path__ + "img/hjk.0d55db7f.jpg";